import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const IrelandFlag: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[16px]', className)}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_ireland)">
      <rect width="8" height="16" fill="#169B62" />
      <rect x="8" width="8" height="16" fill="#FFFFFF" />
      <rect x="16" width="8" height="16" fill="#FF883E" />
    </g>
    <defs>
      <clipPath id="clip0_ireland">
        <rect width="24" height="16" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IrelandFlag;
